/** @format */
import { css } from 'styled-components';

import { StyledIconListItemProps } from './types';

/* eslint-disable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */
const baseStyles = ({ isTransparent }: StyledIconListItemProps) => css`
    list-style-type: none;
    margin-bottom: 1.2rem;
    display: flex;
    opacity: ${isTransparent ? 0.6 : 1};
    gap: var(--layout-spacing-12);
    align-items: center;

    .icon {
        display: flex;
        align-items: center;
    }

    .content {
        flex-grow: 1;
    }
`;
/* eslint-enable @mpb-com/mpb/use-design-tokens -- Legacy code: do not use as an example. */

export const styles = (props: StyledIconListItemProps) => css`
    ${baseStyles(props)}
`;
